export enum ReportTypeDisplayValues {
    All = 'All Report Types',
    Invoice = 'Invoice',
    Payment = 'Payment',
    EarlyPaymentEligible = 'Early Payment Eligible'
}

export enum DateRange {
    Custom = 'custom',
    Today = 'today',
    QuarterToDate = 'quarterToDate',
    WeekToDate = 'weekToDate',
    MonthToDate = 'monthToDate',
    YearToDate = 'yearToDate',
    LastWeek = 'lastWeek',
    LastMonth = 'lastMonth',
    LastYear = 'lastYear'
}

export enum ReportType {
    All = 'ALL',
    Payment = 'Payment',
    Invoice = 'Invoice',
    EarlyPaymentEligible = 'EarlyPaymentEligible'
}

export const ReportStatusDisplayValues = {
    ['ALL']: 'All Invoices',
    ['ALL_PAYMENTS']: 'All Payments',
    ['ELIGIBLE']: 'Eligible',
    ['PENDING']: 'Pending',
    ['PAID']: 'Paid',
    ['EARLY_PAID']: 'Early Paid',
    ['INELIGIBLE']: 'Ineligible',
    ['CLOSED']: 'Closed',
    ['SCHEDULED']: 'Scheduled',
    ['PROCESSING']: 'Processing'
};

export enum ReportStatus {
    All = 'ALL',
    AllPayments = 'ALL_PAYMENTS',
    Eligible = 'ELIGIBLE',
    Pending = 'PENDING',
    EarlyPaid = 'EARLY_PAID',
    Ineligible = 'INELIGIBLE',
    Paid = 'PAID',
    Closed = 'CLOSED',
    Scheduled = 'SCHEDULED',
    Processing = 'PROCESSING'
}

export enum FilterBy {
    InvoiceDate = 'invoiceDate',
    PaidDate = 'paidDate',
    DueDate = 'dueDate'
}

export const filterByDisplayValues = {
    invoiceDate: 'Invoice Date',
    paidDate: 'Payment Date',
    dueDate: 'Due Date'
};

export const columnNamesForKeys = {
    invoiceNumber: 'Invoice #',
    groupId: 'Group ID',
    invoiceDate: 'Invoice Date',
    dueDate: 'Due Date',
    dueIn: 'Due In',
    buyerName: 'Buyer',
    approvedInvoiceAmount: 'Invoice Amount',
    feeAmount: 'Fees',
    eligibleFeeAmount: 'Fees',
    feeRate: 'Fee Rate',
    supplierStatus: '', // depends on the report type
    paymentMethod: 'Payment Method',
    paidDate: 'Payment Date',
    availableAmount: 'Available Amount',
    paidAmount: 'Payment Total'
};

export enum FileType {
    Csv = 'csv',
    Excel = 'xlsx'
}

export const apiDateFormat = 'yyyy-MM-dd';

export enum CompanyRole {
    Buyer = 1,
    Seller = 2
}

export const maxDateMillis = 8640000000000000;

export const columnsForReportType = {
    ['Invoice']: [
        'supplierStatus',
        'invoiceNumber',
        'groupId',
        'invoiceDate',
        'paidDate',
        'buyerName',
        'approvedInvoiceAmount',
        'dueIn',
        'dueDate',
        'feeRate',
        'feeAmount',
        'paidAmount'
    ],
    ['Payment']: [
        'supplierStatus',
        'invoiceNumber',
        'groupId',
        'invoiceDate',
        'paidDate',
        'buyerName',
        'approvedInvoiceAmount',
        'dueIn',
        'dueDate',
        'feeRate',
        'feeAmount',
        'paidAmount',
        'paymentMethod'
    ],
    ['EarlyPaymentEligible']: [
        'supplierStatus',
        'invoiceNumber',
        'groupId',
        'invoiceDate',
        'buyerName',
        'approvedInvoiceAmount',
        'dueIn',
        'dueDate',
        'feeRate',
        'feeAmount',
        'availableAmount'
    ]
};
